import React, { useRef, useState, useEffect } from "react";

import { Root, Container, Main, HeroTitle, Call, Note } from "./Home.style";

import titleSrc from "../../images/hero-title.png";

import useIntersection from "../../hooks/useIntersection";

import EmailCTA from "../EmailCTA/EmailCTA";
import ModalRules from "../ModalRules/ModalRules";

const Home = ({ id, onIntersected }) => {
  const ref = useRef(null);
  const isIntersected = useIntersection(ref);
  const [rulesShow, setRulesShow] = useState(false);

  useEffect(() => {
    if (isIntersected) {
      onIntersected();
    }
  }, [isIntersected, onIntersected]);

  return (
    <Root ref={ref} id={id}>
      <Container>
        <Main>
          <HeroTitle src={titleSrc} alt="amp up your grillin’ & chillin’" />

          <Call>
            <div>ENTER FOR A CHANCE TO</div>
            <span>
              win a big green egg<sup>®</sup> &&nbsp;ultimate fall bbq package
            </span>
          </Call>

          {/* <Call>
            <span>SWEEPSTAKES HAS ENDED.</span> THANKS TO ALL WHO ENTERED!
          </Call> */}

          {/* <EmailCTA /> */}

          <Note>
            Sweepstakes ended on November 30th, 2023. Please see{" "}
            <button onClick={() => setRulesShow(true)}>official rules</button>{" "}
            for details.
          </Note>
        </Main>
      </Container>

      {rulesShow && <ModalRules onClose={() => setRulesShow(false)} />}
    </Root>
  );
};

export default Home;
